module.exports = __webpack_public_path__ + "img/sugonlogo.1988826b.png";